import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/StaffLogin.css"; // Link to the new CSS file

// The constants and function logic remain unchanged
const ROLE_REDIRECTS = {
  superadmin: "/superadmin/dashboard",
  admin: "/admin/dashboard",
  employee: "/employee/dashboard",
};

const ROLE_LABELS = {
  superadmin: { label: "Super Admin", icon: "🛡️", color: "#f59e0b" },
  admin: { label: "Admin", icon: "👑", color: "#6c63ff" },
  employee: { label: "Employee", icon: "🧑‍💼", color: "#10b981" },
};

export default function StaffLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(
        "https://lightslategrey-mole-360881.hostingersite.com/api/auth/staff-login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ email, password }),
        },
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Login failed");
      }

      if (!data.token) {
        console.error("No token in response!");
        throw new Error("No token received from server");
      }

      const role = data.role;
      const token = data.token;

      if (!role || !ROLE_REDIRECTS[role]) {
        throw new Error("Unauthorized access. Invalid role.");
      }

      localStorage.setItem("kkb_token", token);
      localStorage.setItem(
        "kkb_user",
        JSON.stringify({
          id: data.id,
          name: data.name,
          email: data.email,
          role: data.role,
        }),
      );

      navigate(ROLE_REDIRECTS[role]);
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="kkb-staff-portal-page-container">
      {/* Left Panel: Form Section */}
      <div className="kkb-staff-login-form-panel">
        <div className="kkb-staff-portal-logo-container">
          <div className="kkb-logo-icon-cubes">
            <div className="kkb-cube kkb-cube-1"></div>
            <div className="kkb-cube kkb-cube-2"></div>
            <div className="kkb-cube kkb-cube-3"></div>
            <div className="kkb-cube kkb-cube-4"></div>
          </div>
          <span className="kkb-logo-text-factory">KKB</span>
        </div>

        <div className="kkb-staff-portal-welcome-text-container">
          <h2 className="kkb-portal-welcome-title">Welcome back</h2>
          <p className="kkb-portal-welcome-subtitle">
            Please enter your details
          </p>
        </div>

        {/* The original form is preserved */}
        <form onSubmit={handleLogin} className="kkb-staff-login-form">
          <div className="kkb-input-group">
            <label htmlFor="email" className="kkb-input-label">
              Email address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="kkb-form-input"
            />
          </div>
          <div className="kkb-input-group">
            <label htmlFor="password" className="kkb-input-label">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="kkb-form-input"
            />
          </div>

          <div className="kkb-form-options-row">
            <div className="kkb-remember-checkbox-group">
              <input
                type="checkbox"
                id="remember-for-30-days"
                className="kkb-remember-checkbox"
              />
              <label
                htmlFor="remember-for-30-days"
                className="kkb-remember-label"
              >
                Remember for 30 days
              </label>
            </div>
            <a href="/forgot-password" className="kkb-forgot-password-link">
              Forgot password
            </a>
          </div>

          {error && <div className="kkb-error-alert">⚠️ {error}</div>}

          {/* Primary sign-in button uses the loading logic */}
          <button
            type="submit"
            disabled={loading}
            style={{
              background: loading ? "#ddd" : "#6b0c0e", // Keep the original loading background
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
            }}
            className="kkb-sign-in-button kkb-primary-sign-in-button"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>

      {/* Right Panel: Illustration Section */}
      <div className="kkb-staff-portal-illustration-panel">
            <img src="/kkblogo.png" alt="" />
      </div>
    </div>
  );
}
